import { Trans } from 'react-i18next';
import { createI18nService } from './createI18nService';
import useTranslation from './hooks/useTranslation';
import LanguageSwitcher from './LanguageSwitcher';
import LocalizedContent from './LocalizedContent';
import { TFunction, IConfig, I18nInstanceType } from './types';
import { I18nInstance } from './constants';

export { createI18nService, useTranslation, Trans, LanguageSwitcher, I18nInstance, LocalizedContent };
export type { TFunction, IConfig, I18nInstanceType };
